function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "finals"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.78,232.14c11.26-13,55.63-79.86,70.63-127.47A75.42,75.42,0,1,0,4.28,94.16l0,0c.11.51.24,1,.36,1.53s.3,1.21.46,1.81C17.49,145.25,65.94,218.47,77.78,232.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.78,232.14l1.89,1.64c1.48-1.72,3.43-4.22,5.78-7.42a594.7,594.7,0,0,0,33.81-53c12.63-22.18,24.87-46.78,31.53-67.91l-2.38-.75,2.34.88A77.91,77.91,0,1,0,0,77.91,78.57,78.57,0,0,0,1.83,94.69l2.45-.53,1.46-2h0L.33,88.22l1.49,6.49c.12.52.25,1,.37,1.55h0c.15.62.31,1.24.48,1.88v0c3.17,12.17,8.57,25.82,15.09,39.7a581.38,581.38,0,0,0,33,59.64c5.47,8.73,10.61,16.48,15,22.71s7.87,10.92,10.2,13.62L77.78,236l1.89-2.18-1.89-1.64,1.89-1.64c-1.4-1.61-3.43-4.22-5.88-7.58a603.91,603.91,0,0,1-35.63-56.46c-6.54-11.72-12.88-24-18.24-35.89A218.36,218.36,0,0,1,7.5,96.85v0c-.16-.57-.3-1.15-.45-1.75h0c-.12-.52-.25-1-.36-1.5l-2.43.56-1.47,2h0L8.12,100l-1.4-6.4a72.9,72.9,0,1,1,139.35,10.16l0,.06,0,.08c-7.38,23.46-22.16,52-36.48,76.19-7.16,12.1-14.21,23.13-20.15,31.92-3,4.4-5.68,8.24-8,11.37s-4.2,5.57-5.53,7.1l1.89,1.64,1.89-1.64Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 22.68,
  y: 74.91,
  width: 110.45,
  height: 8.99,
  rx: 2.93
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M125.11,34.68H108.36a2,2,0,0,0-1.76-1.11,2,2,0,0,0-2,2v87.82a2,2,0,0,0,3.74.85h16.74a1.49,1.49,0,0,0,1.49-1.49V36.17A1.49,1.49,0,0,0,125.11,34.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.36,34.64H47.11a2,2,0,0,1,1.76-1.11,2,2,0,0,1,2,2v87.81a2,2,0,0,1-3.74.86H30.36a1.49,1.49,0,0,1-1.49-1.49V36.12A1.49,1.49,0,0,1,30.36,34.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M63.41,124.38V108.43a11.86,11.86,0,0,1-3.95,1.89v-1.6a13.17,13.17,0,0,0,4.38-2.66h1.48v18.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M69.56,124.38v-.11c0-2.43,1.85-5.21,5.53-8,3-2.36,3.85-3.09,3.85-5.26a3.2,3.2,0,0,0-3.48-3.48c-2.36,0-3.54,1.17-4,3.63H69.64a5.49,5.49,0,0,1,5.82-5.28c3.87,0,5.45,2.57,5.45,5.06,0,2.79-1.18,3.79-4.55,6.48-2.61,2.08-4.11,3.7-4.62,5.29h9.9l-.29,1.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M84.27,110.38c.29-2.25,1.9-4.54,5.53-4.54s5.28,2.27,5.28,4.64a3.81,3.81,0,0,1-2.5,3.8v0A4.54,4.54,0,0,1,95.89,119c0,3-1.88,5.71-6.14,5.71-3.92,0-5.74-2.51-6-4.94h1.88a4.14,4.14,0,0,0,4.28,3.3,3.74,3.74,0,0,0,4-4c0-2.69-1.71-3.82-4.3-3.82H88.43v-1.6h1c2.59,0,3.74-1.06,3.74-3.1,0-1.79-1.22-3-3.41-3a3.36,3.36,0,0,0-3.64,2.89Z"
})));

var SvgAxleCounter = function SvgAxleCounter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 155.81 235.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAxleCounter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/axle-counter.6cddf196.svg";
export { ForwardRef as ReactComponent };